<template>
    <AnimationWrapper>
        <template #animationContent>
            <div v-if="portfolio.description"
                 :class="['ufo--page-hero-text',
                 portfolio.templateSettings.hero && portfolio.templateSettings.hero.textAlign ? 'align-text-' + portfolio.templateSettings.hero.textAlign : '']"
                 v-on:scroll.native="portfolio.templateSettings.theme === 'profile_theme_nine' ? scrolledDown() : null"
            >
                <div v-if="user.description" class="ufo--page-hero-text">{{ refactorString(user.description) }}</div>
            </div>
        </template>
    </AnimationWrapper>
    <AnimationWrapper>
        <template #animationContent>
            <UserSocialLinks v-if="socialLinksAreInHero()" />
        </template>
    </AnimationWrapper>
</template>

<script>
    import AnimationWrapper from "../../../../common/components/AnimationWrapper.vue";
    import UserSocialLinks from "./UserSocialLinks.vue";
    import {SocialLinksLocationEnum} from "../../../../common/enums.js";
    import {mapGetters} from "vuex";

    export default {
        name: "UserDescription",
        components: {UserSocialLinks, AnimationWrapper},
        methods: {
            refactorString(data) {
                return data.replace("\n", "<br />").replace('<a href', '<a rel="nofollow" href');
            },
            socialLinksAreInHero() {
                return this.portfolio.templateSettings.navigation.socialLinksLocation === SocialLinksLocationEnum.INLINE_ABOVE_TEXT
                    || this.portfolio.templateSettings.navigation.socialLinksLocation === SocialLinksLocationEnum.INLINE_BELOW_TEXT
            },
        },
        computed: {
            ...mapGetters("view", ["viewData"]),
            user() {
                return this.viewData.user
            }
        }
    }
</script>